<template>
	<span class="to-breadcrumb-item">
		<span :class="['to-breadcrumb-item-label', to ? 'is-link' : '']" role="link" @click="handleClick">
			<slot></slot>
		</span>
		<span v-if="!breadcrumbData?.separatorIcon" class="to-breadcrumb-item-separator">{{ breadcrumbData?.separator }}</span>
		<to-icon v-else class="to-breadcrumb-item-separator" :value="breadcrumbData?.separatorIcon"></to-icon>
	</span>
</template>

<script lang="ts">
import { defineComponent, inject, getCurrentInstance } from 'vue'
import { breadcrumbItemProps } from './breadcrumb-item'

export default defineComponent({
	name: 'ToBreadcrumbItem',
	props: breadcrumbItemProps,
	setup(props) {
		const breadcrumbData = inject('breadcrumb', { separator: '/', separatorIcon: '' })

		const handleClick = () => {
			if (!props.to || !router) return

			const routes = router.resolve(props.to)
			const routerMethod = props.replace ? router.replace : router.push
			routerMethod(routes.href)
		}

		const router = getCurrentInstance()?.appContext.config.globalProperties.$router || undefined

		return {
			breadcrumbData,
			handleClick
		}
	}
})
</script>
